<template>
  <svg-icon type="mdi" :path="path"></svg-icon>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiArrowRight } from '@mdi/js'

export default {
  name: 'IconArrowLeft',
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiArrowRight
    }
  }
}
</script>
